import { Typography } from '@mui/material';
import React, { FC, ReactElement } from 'react';

const Tooltip = React.lazy(() => import('@mui/material/Tooltip'));

interface LazyTooltipProps {
  placement?: "bottom" | "bottom-end" | "bottom-start" |
             "left" | "left-end" | "left-start" |
             "right" | "right-end" | "right-start" |
             "top" | "top-end" | "top-start" ;
  title: string;
  children: ReactElement;
}

export const LazyTooltip:FC<LazyTooltipProps> = ({ 
  children, 
  title, 
  placement 
}): ReactElement => {
  return (
    <React.Suspense fallback={children}>
      <Tooltip 
        arrow 
        placement={placement} 
        title={
          <Typography 
            variant='caption' 
            sx={{fontFamily:'B Nazanin'}}
          >
            {title}
          </Typography>
        } 
      >
        {children}
      </Tooltip>
    </React.Suspense>
  );
}
